/**
 * DashboardCtrl controller
 */

import { PROVIDERS_CONST } from 'app/core/constants'

import Chart from 'chart.js/auto'
import am4geodataWorldLow from '@amcharts/amcharts4-geodata/worldLow'

/**
 * DashboardCtrl controller
 *
 * @class DashboardCtrl
 * @memberof mwApp/home
 * @see mwApp/home
 *
 * @ngdoc controller
 * @name mwApp/home.controller:DashboardCtrl
 */
/* @ngInject */
export default function DashboardCtrl ($scope, $http, dragulaService, alertLiteSvc, storageSvc, Dashboard, DashboardPayments, DashboardDevices, DashboardSubscribers, Epg, Show, VOD, LiveEvent, ChannelDTO, Catchup, LiveRewind, Stream, settings, authSvc) {
  var vm = this
  vm.isSuperAdmin = authSvc.hasAccess('superAdmin')
  vm.isSystemUser = storageSvc.local.get('userType') === 'SYSTEM'
  vm.settings = settings
  vm.providersConst = PROVIDERS_CONST
  vm.PROVIDER = window.ENV.APP_PROVIDER
  vm.settings.PAYMENTS_BY_TYPES_GRAPH.period = 7

  vm.countryCount = { label: 'Top 10', count: 10 }
  vm.countryCounts = [{ label: 'Top 5', count: 5 }, { label: 'Top 10', count: 10 }, { label: 'Top 20', count: 20 }]
  vm.periods = [7, 14, 31]
  vm.salesRevenuePeriod = 7
  vm.infos = []
  const style = getComputedStyle(document.body)

  $http.get('api/info/system')
    .data()
    .then(
      (infos) => {
        for (const key in infos) {
          if (Object.prototype.hasOwnProperty.call(infos, key)) {
            //

            // Nora version
            const value =
              key === 'Middleware version'
                ? infos[key].split('#')[0]
                : infos[key]

            const entry = { key, value }

            if (key === 'PID') {
              vm.infos.unshift(entry)
            } else {
              vm.infos.push(entry)
            }
          }
        }
      }
    )

  vm.paymentInformationCards = ['AUTOPAY_PAYMENTS_CARD', 'ALL_PAYMENTS_CARD', 'CASH_PAYMENTS_CARD', 'AUTHORIZE_PAYMENTS_CARD', 'CHECK_PAYMENTS_CARD', 'EXTERNAL_PAYMENTS_CARD', 'CCPP_PAYMENTS_CARD', 'GR4VY_PAYMENTS_CARD', 'GOCARDLESS_PAYMENTS_CARD', 'TRUE_MONEY_PAYMENTS_CARD', 'TRUE_ONLINE_PAYMENTS_CARD', 'TRUE_MOVE_H_PAYMENTS_CARD', 'PAYPAL_PAYMENTS_CARD']

  vm.devices = [
    { platform: 'STB', label: 'STB', count: 0, color: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-14'))(), hColor: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-14-hovered'))() },
    { platform: 'ANDROID', label: 'Android', count: 0, color: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-7'))(), hColor: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-7-hovered'))() },
    { platform: 'IOS', label: 'iOS', count: 0, color: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-3'))(), hColor: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-3-hovered'))() },
    { platform: 'TVOS', label: 'tvOS', count: 0, color: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-5'))(), hColor: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-5-hovered'))() },
    { platform: 'PC', label: 'LG', count: 0, color: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-9'))(), hColor: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-9-hovered'))() },
    { platform: 'SAMSUNGTV', label: 'SamsungTV', count: 0, color: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-11'))(), hColor: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-11-hovered'))() },
    { platform: 'OTHERS', label: 'Others', count: 0, color: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-13'))(), hColor: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-13-hovered'))() },
    { platform: 'WEB', label: 'Web', count: 0, color: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-8'))(), hColor: (() => style.getPropertyValue('--nora_colors_2024_additional_additional-8-hovered'))() }
  ]

  vm.streams = [
    { label: 'Enabled', count: 0 },
    { label: 'Restarted', count: 0 },
    { label: 'Disabled', count: 0 }
  ]

  vm.createCountryChart = function (sudo = false) {
    if ((!vm.firstTime && vm.loadedData) || sudo) {
      if (sudo) {
        vm.countryChartData.destroy()
        vm.countryChartLegend.destroy()
      }
      vm.firstTime = true
      const labels = vm.topCountryData.map((c) => c.label)
      const counts = vm.topCountryData.map((c) => c.count)
      if (labels.length > vm.countryCount.count) {
        counts.length = vm.countryCount.count
        labels.length = vm.countryCount.count
      }
      const backgroundColor = vm.topCountryData.map(c => {
        if (c.count / vm.topCountryData[0].count >= 0.5) {
          return style.getPropertyValue('--nora_colors_2024_additional_additional-14')
        }
        if (c.count / vm.topCountryData[0].count < 0.5 && c.count / vm.topCountryData[0].count >= 0.25) {
          return style.getPropertyValue('--nora_colors_2024_additional_additional-6')
        }
        return style.getPropertyValue('--nora_colors_2024_additional_additional-11')
      })

      const data = {
        labels,
        datasets: [{
          label: 'Device Count',
          data: counts,
          backgroundColor,
          borderRadius: [50]
        }]
      }

      // config
      const config = {
        type: 'bar',
        data,
        options: {
          maintainAspectRatio: false,
          layout: {
            padding: {
              right: 2
            }
          },
          indexAxis: 'y',
          scales: {
            x: {
              beginAtZero: true,
              grid: {
                drawTicks: false,
                drawBorder: false,
                display: false
              },
              ticks: {
                display: false
              }
            },
            y: {
              beginAtZero: true,
              grid: {
                display: false,
                drawBorder: false
              },
              ticks: {
                color: style.getPropertyValue('--nora_colors_2024_text-icon_secondary')
              }
            }
          },
          plugins: {
            legend: {
              display: false
            }
          }
        }
      }

      // render init block
      vm.countryChartData = new Chart(
        document.getElementById('countryChartData'),
        config
      )

      const legendData = {
        labels: [],
        datasets: [{
          label: 'Weekly Sales',
          data: vm.countryChartData.data.datasets[0].data
        }]
      }

      // config
      const legendConfig = {
        type: 'bar',
        data: legendData,
        options: {
          maintainAspectRatio: false,
          indexAxis: 'y',
          scales: {
            x: {
              beginAtZero: true,
              afterFit: (context) => {
                context.height += 40
              },
              ticks: {
                color: style.getPropertyValue('--nora_colors_2024_text-icon_secondary')
              },
              grid: {
                color: style.getPropertyValue('--nora_colors_2024_border_primary')
              }
            },
            y: {
              afterFit: (context) => {
                context.width += vm.countryChartData.chartArea.left
              },
              grid: {
                drawTicks: false
              }
            }
          },
          plugins: {
            legend: {
              display: false
            }
          }
        }
      }

      // render init block
      vm.countryChartLegend = new Chart(
        document.getElementById('countryChartLegend'),
        legendConfig
      )
      const scrollBoxBody = document.querySelector('.scrollBoxBody')
      if (vm.countryChartData.data.labels.length > 9) {
        const newHeight = 350 + ((vm.countryChartData.data.labels.length - 10) * 35)
        scrollBoxBody.style.height = `${newHeight}px`
      }
      if (vm.countryChartData.data.labels.length < 10) {
        const newHeight = 350 + ((vm.countryChartData.data.labels.length - 10) * 35)
        scrollBoxBody.style.height = `${newHeight}px`
      }
      vm.showCountryChart = true
    }
  }

  vm.createTotalDevicesChart = function () {
    if (!vm.firstTimeDevice) {
      const data = {
        labels: vm.devices.map(d => d.label),
        datasets: [{
          data: vm.devices.map(d => d.count),
          backgroundColor: vm.devices.map(d => d.color),
          hoverBackgroundColor: vm.devices.map(d => d.hColor),
          borderColor: style.getPropertyValue('--nora_colors_2024_surface_surface-1')
        }]
      }
      const config = {
        type: 'doughnut',
        data: data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            }
          }
        }
      }
      vm.totalDevicesChart = new Chart(
        document.getElementById('totalDevicesChart'),
        config
      )
      vm.firstTimeDevice = true
    }
  }

  vm.loadImage = function (img) {
    return require('../../img/' + vm.PROVIDER + '/' + vm.PROVIDER + img)
  }

  if (!authSvc.hasEnabledFlag('FEATURE_SECURED_DASHBOARD_ENABLED') || authSvc.hasAccess('viewDashboard')) {
    // load devices data
    vm.dashboardDevices = new DashboardDevices()
    vm.dashboardDevices._loadMap({ precision: 1 })
      .then(() => {
        vm.countries = am4geodataWorldLow.features
        vm.topCountryData = vm.dashboardDevices.map.points.map(p => {
          return { count: p.count, label: vm.countries.find(c => c.id === p.countryIsoCode)?.properties.name }
        })
        vm.topCountryData.sort((a, b) => {
          return a.count < b.count ? 1 : -1
        })
        vm.loadedData = true
        $scope.$broadcast('loadMap', true)
      })

    // load subscribers metrics
    vm.dashboardSubscribers = new DashboardSubscribers()

    vm.dashboardSubscribers.loadMetrics(settings)
      .then(() => {
        vm.loadedSubscriptionMetrics = true
        $scope.$broadcast('loadMetrics', true)
      })

    // load subscribers graph
    vm.loadActiveSubscribersGraph = function () {
      vm.loadActiveSubscribers = true
      $scope.$broadcast('loadGraphActiveSubscribers', false)
      vm.dashboardSubscribers._loadGraph({
        statuses: ['ACTIVE'],
        days: vm.settings.ACTIVE_SUBSCRIBERS_GRAPH_CARD.period
      },
      function (payload) {
        this.activeSubscribersGraph = payload
        $scope.$broadcast('loadGraphActiveSubscribers', true)
        vm.loadActiveSubscribers = false
      })
    }
    vm.loadActiveSubscribersGraph()

    // load payload extra
    vm.currencies = []
    vm.dashboardPayments = new DashboardPayments()
    DashboardPayments.loadPayloadExtra()
      .then((result) => {
        vm.currencies = result.currencies || []

        vm.currencies.length && vm.loadPaymentMetrics()
        vm.currencies.length && settings.PAYMENTS_BY_TYPES_GRAPH.enabled && vm.loadGraphByPaymentSystem()
      })

    vm.loadGraphByPaymentSystem = function () {
      vm.loadGraphDynamicsByPaymentSystem = true
      $scope.$broadcast('loadGraphDynamicsByPaymentSystem', false)
      const typeGraphPromises = []
      for (const currency of vm.currencies) {
        typeGraphPromises.push(vm.dashboardPayments._loadAggregateGraphPayment({
          'agg-type': 'SUM',
          'system-type': settings.PAYMENTS_BY_TYPES_GRAPH.systemTypes.join(','),
          currencyId: currency.id,
          days: vm.settings.PAYMENTS_BY_TYPES_GRAPH.period
        }))
      }

      Promise.all(typeGraphPromises)
        .then((res) => {
          vm.dashboardPayments.paymentsBySystemTypeGraph = res.map(r => r.graphView)
        }).finally(() => {
          $scope.$broadcast('loadGraphDynamicsByPaymentSystem', true)
          vm.loadGraphDynamicsByPaymentSystem = false
        })
    }

    vm.loadPaymentMetrics = function () {
      vm.loadMetrics = true
      $scope.$broadcast('loadPaymentsMetrics', false)
      const metricsPromises = []
      for (const currency of vm.currencies) {
        metricsPromises.push(vm.dashboardPayments.loadMetrics(currency.id, settings, vm.salesRevenuePeriod))
      }

      Promise.all(metricsPromises)
        .then()
        .finally(() => {
          $scope.$broadcast('loadPaymentsMetrics', true)
          vm.loadMetrics = false
        })
    }

    // -

    const dashboard = new Dashboard()
    vm.structure = dashboard.structure() // init dashboard structure

    /**
     * Convert count to human readable string, e.g. 2354 -> 2,354
     *
     * @memberof mwApp/home.controller:DashboardCtrl
     * @param  {Number} n
     * @return {String}
     */
    vm.toNumberString = function (n) {
      return String(n).replace(/(\d)(?=(\d{3})+$)/g, '$1,')
    }

    /**
     * Table state for pageable request
     */
    vm.initTableState = {
      pagination: { start: 0, number: 1 },
      sort: { predicate: 'name', reverse: false },
      search: { predicateObject: { status: 'ENABLED' } }
    }

    if (authSvc.hasEnabledFlag('FEATURE_STREAM_SERVICES_ENABLED')) {
      const streamPromises = []
      streamPromises.push(Stream.loadSmart({
        ...angular.copy(vm.initTableState),
        search: { predicateObject: { 'work-status': 'STARTED' } }
      }))
      streamPromises.push(Stream.loadSmart({
        ...angular.copy(vm.initTableState),
        search: { predicateObject: { 'restart-status': 'RESTARTED' } }
      }))
      streamPromises.push(Stream.loadSmart({
        ...angular.copy(vm.initTableState),
        search: { predicateObject: { 'work-status': 'STOPPED' } }
      }))

      Promise.all(streamPromises).then(res => {
        res.forEach((r, i) => {
          vm.streams[i].count = r.totalElements
        })
        vm.loadedStreamsMetric = true
        $scope.$broadcast('loadStreamsMetric', true)
      })
    }

    Epg.loadEPGS({ ...angular.copy(vm.initTableState), pagination: { start: 0, number: 100 } })
      .then(
        data => {
          vm.epgs = []
          if (data.content) {
            data.content.forEach(d => vm.epgs.push(new Epg(d)))
            vm.showMoreEpgs = vm.epgs.length > 100
            vm.firstEpgsPart = vm.epgs.slice(0, vm.showMoreEpgs ? 50 : Math.ceil(vm.epgs.length / 2))
            vm.secondEpgsPart = vm.epgs.slice(vm.showMoreEpgs ? 50 : Math.ceil(vm.epgs.length / 2))
          }
        }
      )
    const contentPromises = []
    vm.availableContent = [
      {
        label: 'TV Shows',
        total: 0
      },
      {
        label: 'Movies',
        total: 0
      },
      {
        label: 'Live Events',
        total: 0
      },
      {
        label: 'Channels',
        total: 0
      },
      {
        label: 'Catch-ups',
        total: 0
      },
      {
        label: 'Live Rewinds',
        total: 0
      }
    ]

    contentPromises.push(Show.loadSmart(angular.copy(vm.initTableState)))
    contentPromises.push(VOD.loadSmart(angular.copy(vm.initTableState)))
    contentPromises.push(LiveEvent.loadSmart({ ...angular.copy(vm.initTableState), search: { predicateObject: { type: 'TV', status: 'ENABLED', state: 'SOON' } } }))
    contentPromises.push(ChannelDTO.loadSmart({ ...angular.copy(vm.initTableState), search: { predicateObject: { type: 'TV', status: 'ENABLED' } } }))

    if (authSvc.hasEnabledFlag('CATCHUP_ENABLED')) {
      contentPromises.push(Catchup.loadAll())
    } else {
      vm.availableContent.splice(4, 1)
    }

    contentPromises.push(LiveRewind.loadAll())
    Promise.all(contentPromises).then(res => {
      res.forEach((data, index) => {
        if (index < 4) {
          vm.availableContent[index].total = data.totalElements
        } else {
          vm.availableContent[index].total = data.filter(d => d.enabled).length
        }
      })
      vm.loadedContentMetric = true
      $scope.$broadcast('loadContentMetric', true)
    })

    $http.get('/nora/api/dashboard/widgets/devices/platforms/map').then((res) => {
      vm.devices.forEach((device) => {
        device.count = res.data.payload[device.platform]
      })
      vm.devices.sort((a, b) => {
        if (a.count > b.count) return -1
        if (a.count < b.count) return 1
        return 0
      })
      vm.loadedPlatforms = true
      $scope.$broadcast('loadDevicesPlatforms', true)
    })

    vm.showSalesRevenue = function () {
      return vm.paymentInformationCards.reduce((acc, pic) => {
        const card = vm.settings[pic]
        return !!(card && card.enabled) || acc
      }, false)
    }
  }

  vm.showSetup = function () {
    if (authSvc.hasEnabledFlag('FEATURE_SECURED_DASHBOARD_ENABLED')) {
      return authSvc.hasAccess('editDashboard')
    }
    return true
  }

  vm.showMainPage = function () {
    if (authSvc.hasEnabledFlag('FEATURE_SECURED_DASHBOARD_ENABLED')) {
      return authSvc.hasAccess('viewDashboard')
    }
    return true
  }
}
